var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 15.1673C4.04671 15.1673 0.833374 11.954 0.833374 8.00065C0.833374 4.04732 4.04671 0.833984 8.00004 0.833984C11.9534 0.833984 15.1667 4.04732 15.1667 8.00065C15.1667 11.954 11.9534 15.1673 8.00004 15.1673ZM8.00004 1.83398C4.60004 1.83398 1.83337 4.60065 1.83337 8.00065C1.83337 11.4007 4.60004 14.1673 8.00004 14.1673C11.4 14.1673 14.1667 11.4007 14.1667 8.00065C14.1667 4.60065 11.4 1.83398 8.00004 1.83398Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4733 10.6192C10.3867 10.6192 10.3 10.5992 10.22 10.5459L8.15334 9.31253C7.64001 9.00586 7.26001 8.33253 7.26001 7.73919V5.00586C7.26001 4.73253 7.48668 4.50586 7.76001 4.50586C8.03334 4.50586 8.26001 4.73253 8.26001 5.00586V7.73919C8.26001 7.97919 8.46001 8.33253 8.66668 8.45253L10.7333 9.68586C10.9733 9.82586 11.0467 10.1325 10.9067 10.3725C10.8067 10.5325 10.64 10.6192 10.4733 10.6192Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.dc4a8dc05d98be3d99668b66853d9c98.svg";
export { ForwardRef as ReactComponent };